export default __webpack_public_path__ + "static/media/lc_logo.b8057d09.png";